<template>
  <div
    v-if="results || legacyResult"
    class="si-report-value-bar teal white--text headline si-print-background"
    style="min-height: 50px;"
  >
    <div
      v-if="results"
      class="my-n1"
    >
      <div
        v-for="(result, i) in results"
        :key="`report_${i}`"
        class="my-1"
        :class="{'mt-2': i > 0}"
      >
        {{ result }}
      </div>
    </div>
    <span v-else>{{ legacyResult ? _$(legacyResult) : '' }}</span>
  </div>
</template>
<script>
import helpers from '@/mixins/helpers'


export default {
  mixins: [ helpers ],
  props: {
    data: {
      type: Object,
      default: () => { return {} }
    },
  },
  computed: {
    report () {
      return this.data.report || {}
    },
    legacyResult () {
      return (this.data.result || {}).value
    },
    results () {
      return this.report.results
    }
  }
}
</script>
<style lang="scss" scoped>
  .si-report-value-bar {
    @media print {
      padding: 12px 16px;
      margin-bottom: 12px;
    }
    @media screen {
      padding: 12px 32px;
      margin: 0 -32px 12px;
    }
  }
</style>